<template>
  <div class="risk-score column" :class="issue.severity.toLowerCase()">
    <span>{{ formatRiskScore }}</span>
  </div>
</template>

<script>
export default {
  name: 'IssueRiskScore',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formatRiskScore() {
      const { riskScore } = this.issue;
      return riskScore?.toFixed?.(1) || riskScore;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.risk-score {
  font-size: $font-size-sm;
  font-weight: bolder;
  letter-spacing: 0;
  line-height: rem(12);
  text-align: center;
  font-family: $font-family-medium;

  span {
    letter-spacing: rem(1);
    padding: rem(2) $space-1;
    border-radius: $radius-sm;
  }
  &.informative {
    color: $severity-trivial;
    span {
      background-color: $severity-trivial-bg;
    }
  }
  &.trivial {
    color: $severity-trivial;
    span {
      background-color: $severity-trivial-bg;
    }
  }
  &.low {
    color: $severity-low;
    span {
      background-color: $severity-low-bg;
    }
  }
  &.medium {
    color: $severity-medium;
    span {
      background-color: $severity-medium-bg;
    }
  }
  &.high {
    color: $severity-high;
    span {
      background-color: $severity-high-bg;
    }
  }
  &.critical {
    color: $severity-critical;
    span {
      background-color: $severity-critical-bg;
    }
  }
  &.blocker {
    color: $severity-critical;
    span {
      background-color: $severity-critical-bg;
    }
  }
}
</style>
